import React, { useEffect, useMemo, useState } from "react"
import { Col, Container, Row, Table } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "pages/Separate/Loader"
import secureLocalStorage from "react-secure-storage"
import moment from "moment"
import { fetchData, fetchNodeData } from "utils/common-fetchData"
import { convertMinutesToTimeString, getFormattedTime } from "utils/common-helpers"
import configure from "configure"
import NewPagination from "components/Common/Newpagination"
import { timeSheetColumns } from "utils/columns/ElementsColumns/supportColumns"
import axios from "axios"
import * as XLSX from "xlsx"
import Swal from "sweetalert2"
import { otherProjectsList } from "utils/common-options"
import { useTable, useSortBy, usePagination } from "react-table"

const TimesheetTable = ({ toDate, activeUser ,onTotalTimeChange  }) => {
  // document.title = "Timesheet Report | Zithas Crm"

  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [rows, setRows] = useState([])
  const [users, setUsers] = useState([])

  const [staff, setStaff] = useState([])
  const [projectOptions, setProjectOptions] = useState([])
  const [digital_projects, setDigitalProjects] = useState([])
  const [allProjects, setAllProjects] = useState([])
const [totalTime, setTotalTime] = useState("00:00:00");
  const toggleLoading = loading => setLoading(loading)

  useEffect(() => {
    fetchStaffAndProjects()
  }, [])

  const fetchStaffAndProjects = async () => {
    try {
      const authToken = secureLocalStorage.getItem("auth_token")
      const datas = await fetchData(toggleLoading, "generalData", authToken)

      const allStaffOption = datas?.data?.staff?.map(obj => ({
        label: obj?.name,
        value: obj.id,
      }))

      const devProjects = datas?.data?.projects?.map(obj => ({
        label: obj?.project_name,
        value: obj.id,
      }))

      const dmProjects = datas?.data?.digital_projects?.map(obj => ({
        label: obj?.project_name,
        value: obj.id,
      }))

      setProjectOptions(devProjects || [])
      setDigitalProjects(dmProjects || [])
      setStaff(allStaffOption || [])
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    // Combine all projects
    if (projectOptions?.length || digital_projects?.length) {
      setAllProjects([
        ...projectOptions.map(p => ({ ...p, label: `${p.label} - Dev`, type: 0 })),
        ...digital_projects.map(p => ({ ...p, label: `${p.label} - DM`, type: 1 })),
        ...otherProjectsList,
      ])
    }
  }, [projectOptions, digital_projects])

  // Fetch timesheet only when activeUser and toDate are provided
  useEffect(() => {
    if (activeUser && toDate) {
      getDataByDate({ value: activeUser }, toDate, toDate)
    }
  }, [activeUser, toDate])

  const getDataByDate = async (selectedStaff, fromDate, toDate) => {
    try {
      if (!fromDate || !toDate) return

      setLoading(true)
      setData([])
      setRows([])

      const workLoadUrl = `${configure.nodeApi}/TimeSheetReport/${fromDate}/${toDate}/${selectedStaff.value}`
      const pendingTaskUrl = `${configure.nodeApi}/pendingTasks/${selectedStaff.value}/${fromDate}/${toDate}`

      const [res, res2] = await Promise.all([axios.get(workLoadUrl), axios.get(pendingTaskUrl)])

      if (res?.data?.success) {
        const fetchedData = res.data.data.allData || []
        const currentUserId = selectedStaff.value

        const filteredData = fetchedData
          .filter(item => (item.user_id === currentUserId || item.staff_id === currentUserId || item?.user?.id === currentUserId) && item.total_actual_time)
          .map(item => ({
            ...item,
            date: moment(item.updated_at).format("DD-MM-YYYY"),
            ...(item.type !== "activity" && item?.timelogs && { todayTime: getFormattedTime(item?.timelogs || []) || null }),
          }))

        setData(filteredData)
      }

      if (res2?.data?.success) setRows(res2.data.data)

      setLoading(false)
    } catch (error) {
      console.error("Error in getDataByDate:", error)
      setLoading(false)
    }
  }

  const totalUsedTime = useMemo(() => {
    const getSeconds = (timeString, type) => {
      if (!timeString) return 0
      if (type === "activity") {
        const [h = 0, m = 0] = timeString.split(":").map(Number)
        return h * 3600 + m * 60
      }
      const [h = 0, m = 0, s = 0] = timeString.split(":").map(Number)
      return h * 3600 + m * 60 + s
    }

    let totalSeconds = 0
    rows.forEach(item => { if (item.approved === 1) totalSeconds += getSeconds(item.totaltime) })
    data.forEach(item => {
      if (item.type === "activity" || item.type === "qa_task") {
        totalSeconds += getSeconds(item.type === "qa_task" ? convertMinutesToTimeString(item.total_actual_time || 0) : item.total_actual_time, "activity")
      } else totalSeconds += getSeconds(item.todayTime)
    })
    return moment.utc(totalSeconds * 1000).format("HH:mm:ss")
  }, [rows, data])

  const totalPendingHours = useMemo(() => {
    let totalSeconds = 0
    rows?.filter(item => item.approved !== 1)?.forEach(r => {
      const [h = 0, m = 0, s = 0] = r?.totaltime?.split(":").map(Number)
      totalSeconds += h * 3600 + m * 60 + s
    })
    return moment.utc(totalSeconds * 1000).format("HH:mm:ss")
  }, [rows])

  const totalIncludingAdditionalTime = totalUsedTime

    useEffect(() => {
    if (onTotalTimeChange) {
      onTotalTimeChange(totalIncludingAdditionalTime);
    }
  }, [totalIncludingAdditionalTime]);



  const handleExport = () => {
    const workbook = XLSX.utils.book_new()
    const exportData = []

data.forEach((list, i) => {
  exportData.push({
    ["Sr No."]: i + 1,
    Type: list.type,
    ["Activity Name"]: list.task_title,
    Date: list.date,
   ["Start Time"]: list.type === "qa_task" ? "--" : moment(list.start_time).format("hh:mm A"),
    ["End Time"]: list.type === "qa_task" ? "--" : moment(list.end_time).format("hh:mm A"),
    ["Total Time"]:
      list.type === "activity"
        ? list.total_actual_time
        : list.type === "qa_task"
          ? convertMinutesToTimeString(list.total_actual_time || 0)
          : list.todayTime || "00:00:00"
      + " hrs",
    Approval: "--",
  });
});

rows.forEach((list, i) => {
  // Determine Type based on project_type
  let typeLabel = "Manual";
  if (list.project_type === 0) typeLabel = "Manual - Development";
  else if (list.project_type === 1) typeLabel = "Manual - Digital Marketing";
  else if (list.project_type === 2) typeLabel = "Manual - Other";

  // Activity Name with project name prefix
  const projectName = list.project?.project_name || "Unknown Project";
  const activityName = `${projectName} - ${list.title}`;

  exportData.push({
    ["Sr No."]: exportData.length + 1,
    Type: typeLabel,
    ["Activity Name"]: activityName,
    Date: moment(list.date).format("DD-MM-YYYY"),
    ["Start Time"]: list.start_time || "--",
    ["End Time"]: list.end_time || "--",
    ["Total Time"]: list.totaltime + " hrs",
    Approval: list.approved === 1
      ? "Approved"
      : list.approved === 0
      ? "Pending"
      : "Disapproved",
  });
});

      // --- Calculate Verified / Unverified ---
  const timeToSeconds = (timeStr) => {
    const [h = 0, m = 0, s = 0] = timeStr.split(":").map(Number);
    return h * 3600 + m * 60 + s;
  };

  const secondsToHMS = (secs) => {
    const h = String(Math.floor(secs / 3600)).padStart(2, "0");
    const m = String(Math.floor((secs % 3600) / 60)).padStart(2, "0");
    const s = String(secs % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  const pendingSeconds = timeToSeconds(totalPendingHours);
  const totalSeconds = timeToSeconds(totalTime);
  const verifiedSeconds = totalSeconds - pendingSeconds;

  exportData.push({
    ["Total Time Taken"]: totalTime + " hrs",
     ["Unverified Time"]: secondsToHMS(pendingSeconds) + " hrs",
    ["Verified Time"]: secondsToHMS(verifiedSeconds) + " hrs",
  });

    const worksheet = XLSX.utils.json_to_sheet(exportData)
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1")
    XLSX.writeFile(workbook, `Timesheet_Report.xlsx`)
  }

  const columns = useMemo(() => timeSheetColumns(true), [])
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    gotoPage,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    state: { pageIndex, pageSize },
  } = useTable(
    { columns, data, initialState: { pageIndex: 0, pageSize: 10 } },
    useSortBy,
    usePagination
  )

  const addTimes = (time1, time2) => {
  const toSeconds = (time) => {
    const [h, m, s] = time.split(":").map(Number);
    return h * 3600 + m * 60 + s;
  };

  const toHHMMSS = (secs) => {
    const h = String(Math.floor(secs / 3600)).padStart(2, "0");
    const m = String(Math.floor((secs % 3600) / 60)).padStart(2, "0");
    const s = String(secs % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  return toHHMMSS(toSeconds(time1) + toSeconds(time2));
};


  useEffect(() => {
  const addTimes = (time1, time2) => {
    const toSeconds = (time) => {
      const [h = 0, m = 0, s = 0] = time.split(":").map(Number);
      return h * 3600 + m * 60 + s;
    };
    const toHHMMSS = (secs) => {
      const h = String(Math.floor(secs / 3600)).padStart(2, "0");
      const m = String(Math.floor((secs % 3600) / 60)).padStart(2, "0");
      const s = String(secs % 60).padStart(2, "0");
      return `${h}:${m}:${s}`;
    };
    return toHHMMSS(toSeconds(time1) + toSeconds(time2));
  };

  setTotalTime(addTimes(totalUsedTime, totalPendingHours));
}, [totalUsedTime, totalPendingHours]);

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <Container fluid>
        {/* <Breadcrumb title="Reports" breadcrumbItem="Timesheet Report" /> */}

        {/* Main Table */}
        {activeUser && (
          <Row>
            {/* LEFT: Assigned Tasks */}
            <Col md="12" className="pb-4">
              <div className="d-flex align-items-start justify-content-between mb-3">
                <div className="d-flex align-items-start gap-3">
                  <div className=" text-purple fs-5 fw-bold  mb-3 mt-1">
                    Assigned Tasks
                  </div>
                  <div className="general-box bg-light ml-3 px-3 fw-semibold text-purple">
                    Verified Time : {totalUsedTime}
                  </div>
                  <div className="general-box bg-light ml-3 px-3 fw-semibold text-purple">
                    Unverified Time : {totalPendingHours}
                  </div>
                  <div className="general-box ml-3 px-3 fw-semibold text-purple">
                    {/* Total Time : {totalIncludingAdditionalTime} */}
                   Total Time : {totalTime}
                  </div>
                </div>

                <div>
                  {data.length || rows.length ? (
                    <button onClick={handleExport} className="btn-success btn">
                      <i className="fas fa-download me-2"></i> Export 
                    </button>
                  ) : null}
                </div>
              </div>

              <div className="table-responsive">
                <Table bordered {...getTableProps()}>
                  <thead>
                    {headerGroups.map((hg, i) => (
                      <tr key={i} {...hg.getHeaderGroupProps()}>
                        {hg.headers.map((col, idx) => (
                          <th key={idx} {...col.getHeaderProps(col.getSortByToggleProps())}>
                            {col.render("Header")}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>

                  <tbody {...getTableBodyProps()}>
                    {page.map((row, i) => {
                      prepareRow(row)
                      return (
                        <tr key={i} {...row.getRowProps()}>
                          {row.cells.map((cell, idx) => (
                            <td key={idx} {...cell.getCellProps()}>{cell.render("Cell")}</td>
                          ))}
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>

              <NewPagination
                gotoPage={gotoPage}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                pageSize={pageSize}
                page={page}
                data={data}
                nextPage={nextPage}
              />
            </Col>

            {/* RIGHT: Manually Added Tasks */}
            <Col md="12" className="pt-4 border-top">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="text-purple fs-5 fw-bold">
                  Manually Added Tasks
                </div>
                <h5 className="text-purple mb-0">
                  Total Hours :
                  <span className="text-primary ms-2">{totalUsedTime}</span>
                </h5>
              </div>

              <div>
                <Table bordered>
                  <thead>
                    <tr>
                      <th className="text-center">#</th>
                      <th>Project</th>
                      <th>Activity Name</th>
                      <th className="col-2 text-center">Date</th>
                      <th className="text-center">Start Time</th>
                      <th className="text-center">End Time</th>
                      <th className="text-center">Total Time</th>
                      <th className="text-center">Approval</th>
                    </tr>
                  </thead>

                  <tbody>
                    {rows.map((row, i) => (
                      <tr key={i}>
                        <td className="text-center">{i + 1}</td>
                        <td>
                          {allProjects?.find(
                            s =>
                              (row.project_type === 2
                                ? s.value === row.other_project_id
                                : s.value === row.project_id) &&
                              s.type === row.project_type
                          )?.label || ""}
                        </td>
                        <td className="text-capitalize">
                          {row.title}{" "}
                          {row.staff && (
                            <b>
                              - {staff?.find(s => s.value === row.staff)?.label}
                            </b>
                          )}
                        </td>
                        <td className="text-center">
                          {moment(row.date).format("DD-MM-YYYY")}
                        </td>
                        <td className="text-center">{row.start_time}</td>
                        <td className="text-center">{row.end_time}</td>
                        <td className="fw-bold text-primary text-center">{row.totaltime}</td>
                        <td className="text-center">
                          <span
                            title={
                              row.approved === 1
                                ? "Approved"
                                : row.approved === 2
                                ? "Rejected"
                                : "Pending"
                            }
                          >
                            {row.approved === 1 ? (
                              <i className="bi bi-check-circle icon-center text-success fs-4 me-2"></i>
                            ) : row.approved === 2 ? (
                              <i className="bi bi-x-circle icon-center text-danger fs-4 me-2"></i>
                            ) : (
                              <i className="bi bi-exclamation-circle icon-center text-warning fs-4 me-2"></i>
                            )}
                            {row.project?.keyAccountManager?.name}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </React.Fragment>
  )
}

export default TimesheetTable